// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2agNi","header":"ClearentDisclaimer_header__35Hl6","inner":"ClearentDisclaimer_inner__3SzZR"};